export const toMapWidgetNodeId = id => `widget:${id}`;
export const toMapShapeNodeId = id => `shape:${id}`;
export const toMapPinNodeId = id => `pin:${id}`;
export const toMapRegionNodeId = id => `region:${id}`;
export const toMapDrawingNodeId = id => `drawing:${id}`;
export const toMapGroupNodeId = id => `group:${id}`;

export const parseMapNodeId = rawNodeId => {
  const value = String(rawNodeId || '');
  const [type, ...rest] = value.split(':');
  return {
    type: type || '',
    id: rest.join(':') || '',
  };
};

export const getMapTargetNodeId = target => {
  if (!(target instanceof Element)) {
    return null;
  }
  return target.closest('[data-map-node-id]')?.getAttribute('data-map-node-id') || null;
};
